export const PLAN_VENTE_BROWSER_MODAL = 'PLAN_VENTE_BROWSER_MODAL'
export const TRANCHE_FORFAIT_TRANSPORT_MODAL = 'TRANCHE_FORFAIT_TRANSPORT_MODAL'
export const FORFAIT_TYPE_MODIFICATION_MODAL = 'FORFAIT_TYPE_MODIFICATION_MODAL'
export const FORFAIT_RESET_MODAL = 'FORFAIT_RESET_MODAL'
export const SELECTION_MODELE_EDITOR_MODAL = 'SELECTION_MODELE_EDITOR_MODAL'
